import { Instagram, MessageCircle, Download, Share2 } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { shareInstagram, shareWhatsApp, downloadCard, shareNative, nativeShareSupported } from "../lib/lookActions";

export const ShareLookMenu = ({ image, productName, children, align = "end" }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="glass border-gold/20 w-52" data-testid="share-menu">
        <DropdownMenuItem onClick={() => shareInstagram(image, productName)} data-testid="share-instagram">
          <Instagram className="w-4 h-4 mr-2 text-gold" /> Instagram Stories
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => shareWhatsApp(image, productName)} data-testid="share-whatsapp">
          <MessageCircle className="w-4 h-4 mr-2 text-gold" /> WhatsApp
        </DropdownMenuItem>
        {nativeShareSupported() && (
          <DropdownMenuItem onClick={() => shareNative(image, productName)} data-testid="share-native">
            <Share2 className="w-4 h-4 mr-2 text-gold" /> More apps…
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={() => downloadCard(image, productName)} data-testid="share-download">
          <Download className="w-4 h-4 mr-2 text-gold" /> Download card
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
